<mat-dialog-content>
    <p>{{header}}</p>
    <button class="mat-raised-button" (click)="cancel()">Mégsem</button>
    <button class="mat-raised-button" (click)="ok()">Igen</button>
</mat-dialog-content>
  